import { useState } from "react"

export const NONE_EXTENSION = "none"
export const LEFT_TABLE_EXTENSION = "left-table"
export const RIGHT_TABLE_EXTENSION = "right-table"
export const TWELVE_DISPLAY_EXTENSION = "12-display"
export const SIX_DISPLAY_EXTENSION = "6-display"

const manageExtension = (extension) => (prevExtensions) => {
  if (extension === NONE_EXTENSION) {
    return [extension]
  }

  if (prevExtensions.includes(extension)) {
    return prevExtensions.filter((p) => p !== extension)
  }
  return prevExtensions.concat([extension]).filter((p) => p !== NONE_EXTENSION)
}

const useCartExtension = () => {
  const [activeExtensions, setSelectedExtensions] = useState([NONE_EXTENSION])

  const onExtensionClick = ({ extension }) => {
    const getNextExtensions = manageExtension(extension)
    setSelectedExtensions((prev) => {
      const nextExtensions = getNextExtensions(prev)
      if (extension === SIX_DISPLAY_EXTENSION) {
        return nextExtensions.filter((p) => p !== TWELVE_DISPLAY_EXTENSION)
      }
      if (extension === TWELVE_DISPLAY_EXTENSION) {
        return nextExtensions.filter((p) => p !== SIX_DISPLAY_EXTENSION)
      }
      return nextExtensions
    })
  }

  return {
    activeExtensions,
    onExtensionClick,
  }
}

export default useCartExtension
